import React, { useEffect, useState, Fragment } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import api from '../../config/axios';
import Breadcrumb from '../common/breadcrumb';
import { date } from '../../utils/date';
import { useStateValue } from '../../store';

const Receipts = () => {
    const [{ auth }] = useStateValue();
    const [receipts, setReceipts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterType, setFilterType] = useState('');

    useEffect(() => {
        fetchReceipts();
    }, []);

    const fetchReceipts = async () => {
        try {
            let url = '/receipt';
            const params = [];
            if (filterType) params.push(`type=${filterType}`);
            if (params.length) url += '?' + params.join('&');
            const { data } = await api.get(url);
            setReceipts(data.data || []);
        } catch (err) {
            toast.error('Error al cargar los recibos');
        } finally {
            setLoading(false);
        }
    };

    const handleFilter = (e) => {
        e.preventDefault();
        setLoading(true);
        fetchReceipts();
    };

    const currencySymbol = (currency) => {
        const symbols = { USD: '$', VES: 'Bs.', COP: '$' };
        return symbols[currency] || '$';
    };

    return (
        <Fragment>
            <Breadcrumb title="Recibos" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5>Recibos</h5>
                                    <Link
                                        to={`${process.env.PUBLIC_URL}/recibos/nuevo`}
                                        className="btn btn-primary btn-sm"
                                    >
                                        <i className="fa fa-plus mr-1"></i>
                                        Nuevo recibo
                                    </Link>
                                </div>
                            </div>
                            <div className="card-body">
                                <form className="form-inline mb-3" onSubmit={handleFilter}>
                                    <div className="form-group mr-3">
                                        <label className="mr-2">Tipo:</label>
                                        <select
                                            className="form-control"
                                            value={filterType}
                                            onChange={(e) => setFilterType(e.target.value)}
                                        >
                                            <option value="">Todos</option>
                                            <option value="prepago">Prepago</option>
                                            <option value="compra_entregada">Compra entregada</option>
                                        </select>
                                    </div>
                                    <button type="submit" className="btn btn-primary btn-sm">
                                        Filtrar
                                    </button>
                                </form>

                                {loading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Cargando...</span>
                                        </div>
                                    </div>
                                ) : receipts.length === 0 ? (
                                    <div className="text-center py-5">
                                        <p style={{ fontSize: 18, color: '#777' }}>
                                            No hay recibos registrados
                                        </p>
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>N°</th>
                                                    <th>Titular</th>
                                                    <th>Tipo</th>
                                                    <th>Total</th>
                                                    <th>Moneda</th>
                                                    <th>Pago</th>
                                                    <th>Fecha</th>
                                                    <th>Email</th>
                                                    <th>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {receipts.map((receipt) => (
                                                    <tr key={receipt.id}>
                                                        <td>
                                                            <strong>#{receipt.receiptNumber}</strong>
                                                        </td>
                                                        <td>{receipt.holderName}</td>
                                                        <td>
                                                            {receipt.type === 'prepago' ? (
                                                                <span className="badge badge-info">
                                                                    Prepago
                                                                </span>
                                                            ) : (
                                                                <span className="badge badge-success">
                                                                    Entregada
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {currencySymbol(receipt.currency)}{' '}
                                                            {Number(receipt.totalAmount).toFixed(2)}
                                                        </td>
                                                        <td>{receipt.currency}</td>
                                                        <td>{receipt.paymentMethod || '-'}</td>
                                                        <td>{date(receipt.createdAt)}</td>
                                                        <td>
                                                            {receipt.emailSentAt ? (
                                                                <span
                                                                    className="badge badge-success"
                                                                    title={`Enviado: ${date(receipt.emailSentAt)}`}
                                                                >
                                                                    <i className="fa fa-envelope"></i> Sí
                                                                </span>
                                                            ) : (
                                                                <span className="badge badge-secondary">
                                                                    No
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <Link
                                                                to={`${process.env.PUBLIC_URL}/recibos/${receipt.id}`}
                                                                className="btn btn-outline-primary btn-sm"
                                                            >
                                                                <i className="fa fa-eye"></i>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Receipts;
